<section class="corte-devolucao" aria-labelledby="corte-devolucao-titulo">
  <h3 id="corte-devolucao-titulo" class="corte-devolucao-titulo">
    Controle de Devoluções
  </h3>

  <div class="corte-devolucao-grid">
    <!-- Elegível -->
    <article class="corte-devolucao-card corte-devolucao-card--elegivel">
      <p class="corte-devolucao-card-label corte-devolucao-card-label--total">
        <span class="corte-devolucao-bola corte-devolucao-bola--verde" aria-hidden="true"></span>
        Barra<span *ngIf="dados.multiploElegivel > 0">({{ fmt(dados.multiploElegivel) }}m)</span>:
        <strong>{{ fmt(dados.sobraElegivel) }}m</strong>
      </p>
      <p
        *ngIf="exibirValorMonetario && valorBarraDisponivel > 0"
        class="corte-devolucao-valor corte-devolucao-valor--disponivel"
      >
        <strong>R$ {{ valorBarraDisponivel | currency:'BRL':'' }}</strong>
      </p>

      <div
        class="corte-devolucao-stepper"
        role="group"
        aria-label="Quantidade a devolver em metros"
      >
        <button
          type="button"
          class="corte-devolucao-stepper-btn"
          [disabled]="bloqueado || qtdElegivel <= 0"
          (click)="ajustarQtd('elegivel', -1)"
        >
          −
        </button>
        <span class="corte-devolucao-stepper-valor">
          <span>{{ fmt(metrosElegivelSelecionados) }}m</span>
          <span
            *ngIf="exibirValorMonetario && valorBarraSelecionado > 0"
            class="corte-devolucao-stepper-valor-moeda"
          >
            R$ {{ valorBarraSelecionado | currency:'BRL':'' }}
          </span>
        </span>
        <button
          type="button"
          class="corte-devolucao-stepper-btn"
          [disabled]="bloqueado || qtdElegivel >= maxQtdElegivel"
          (click)="ajustarQtd('elegivel', 1)"
        >
          +
        </button>
      </div>

      <button
        type="button"
        class="btn btn-block corte-devolucao-btn corte-devolucao-btn--verde"
        [disabled]="bloqueado || qtdElegivel <= 0 || maxQtdElegivel <= 0"
        (click)="emitir('devolver')"
      >
        Devolver
      </button>
    </article>

    <!-- Não elegível -->
    <article class="corte-devolucao-card corte-devolucao-card--nao-elegivel">
      <p class="corte-devolucao-card-label corte-devolucao-card-label--total">
        <span class="corte-devolucao-bola corte-devolucao-bola--vermelho" aria-hidden="true"></span>
        Resíduo<span *ngIf="dados.multiploNaoElegivel > 0">({{ fmt(dados.multiploNaoElegivel) }}m)</span>:
        <strong>{{ fmt(dados.sobraNaoElegivel) }}m</strong>
      </p>
      <p
        *ngIf="exibirValorMonetario && valorResiduoDisponivel > 0"
        class="corte-devolucao-valor corte-devolucao-valor--disponivel"
      >
        <strong>R$ {{ valorResiduoDisponivel | currency:'BRL':'' }}</strong>
      </p>

      <div
        class="corte-devolucao-stepper"
        role="group"
        aria-label="Quantidade não elegível a devolver em metros"
      >
        <button
          type="button"
          class="corte-devolucao-stepper-btn"
          [disabled]="bloqueado || qtdNaoElegivel <= 0"
          (click)="ajustarQtd('naoElegivel', -1)"
        >
          −
        </button>
        <span class="corte-devolucao-stepper-valor">
          <span>{{ fmt(metrosNaoElegivelSelecionados) }}m</span>
          <span
            *ngIf="exibirValorMonetario && valorResiduoSelecionado > 0"
            class="corte-devolucao-stepper-valor-moeda"
          >
            R$ {{ valorResiduoSelecionado | currency:'BRL':'' }}
          </span>
        </span>
        <button
          type="button"
          class="corte-devolucao-stepper-btn"
          [disabled]="bloqueado || qtdNaoElegivel >= maxQtdNaoElegivel"
          (click)="ajustarQtd('naoElegivel', 1)"
        >
          +
        </button>
      </div>

      <button
        type="button"
        class="btn btn-block corte-devolucao-btn corte-devolucao-btn--vermelho"
        [disabled]="bloqueado || qtdNaoElegivel <= 0 || maxQtdNaoElegivel <= 0"
        (click)="emitir('solicitar_autorizacao')"
      >
        Solicitar autorização
      </button>
    </article>

    <!-- Total devolvido -->
    <article class="corte-devolucao-card corte-devolucao-card--devolvido">
      <p
        class="corte-devolucao-card-label corte-devolucao-card-label--total"
        aria-live="polite"
        [attr.aria-label]="
          estornoSelecionado
            ? 'Devolvido: ' + fmt(totalEstornoDisponivel) + ' metros disponíveis para estorno'
            : 'Devolvido: selecione Barra ou Resíduo'
        "
      >
        <span class="corte-devolucao-bola corte-devolucao-bola--azul" aria-hidden="true"></span>
        Devolvido:
        <strong>{{ estornoSelecionado ? fmt(totalEstornoDisponivel) + 'm' : '—' }}</strong>
      </p>

      <div
        class="corte-devolucao-opcoes-estorno"
        role="group"
        aria-label="Tipo de devolução para estorno"
      >
        <button
          type="button"
          class="corte-devolucao-opcao-estorno"
          [class.corte-devolucao-opcao-estorno--selected]="estornoSelecionado === 'barra'"
          [disabled]="bloqueado || !podeEstornarBarra"
          [attr.aria-pressed]="estornoSelecionado === 'barra'"
          (click)="selecionarTipoEstorno('barra')"
        >
          <span class="corte-devolucao-bola corte-devolucao-bola--verde" aria-hidden="true"></span>
          <span class="corte-devolucao-opcao-estorno-titulo">Barra</span>
        </button>

        <button
          type="button"
          class="corte-devolucao-opcao-estorno"
          [class.corte-devolucao-opcao-estorno--selected]="estornoSelecionado === 'residuo'"
          [disabled]="bloqueado || !podeEstornarResiduo"
          [attr.aria-pressed]="estornoSelecionado === 'residuo'"
          (click)="selecionarTipoEstorno('residuo')"
        >
          <span class="corte-devolucao-bola corte-devolucao-bola--vermelho" aria-hidden="true"></span>
          <span class="corte-devolucao-opcao-estorno-titulo">Resíduo</span>
        </button>
      </div>

      <div
        class="corte-devolucao-stepper"
        role="group"
        aria-label="Quantidade de estorno em metros"
      >
        <button
          type="button"
          class="corte-devolucao-stepper-btn"
          [disabled]="bloqueado || !estornoAtivo || qtdEstorno <= 0"
          (click)="ajustarQtd('estorno', -1)"
        >
          −
        </button>
        <span class="corte-devolucao-stepper-valor">
          {{ fmt(metrosEstornoSelecionados) }}m
        </span>
        <button
          type="button"
          class="corte-devolucao-stepper-btn"
          [disabled]="
            bloqueado ||
            !estornoAtivo ||
            maxQtdEstornoAtual <= 0 ||
            qtdEstorno >= maxQtdEstornoAtual
          "
          (click)="ajustarQtd('estorno', 1)"
        >
          +
        </button>
      </div>

      <button
        type="button"
        class="btn btn-block corte-devolucao-btn corte-devolucao-btn--estorno"
        [class.corte-devolucao-btn--estorno-ativo]="podeConfirmarEstorno"
        [disabled]="bloqueado || !podeConfirmarEstorno"
        (click)="emitir('estornar')"
      >
        Estornar
      </button>
    </article>
  </div>
</section>
